import React from 'react';
import { PatientImage } from 'components/Common/UserImage';
import Icon from 'components/Utils/NewIcon';
import PatientUtils from 'services/PatientUtils';
import ChatUtils from 'services/ChatUtils';
import SubscriptionUtils from 'services/SubscriptionUtils';
import RouteUtils from 'services/RouteUtils';
import { useAppSelector } from 'careand-redux/store';
import { useNavStack } from 'careand-redux/slices/ui/hooks';
import { Stacks } from 'careand-redux/slices/ui/navigation';
import { IconButton } from '@material-ui/core';

const EMPTY_PATIENT = {};

/**
 * @param {any} Props
 */
const AdminTopBar = ({
  patient = EMPTY_PATIENT,
  name,
  hideDetails = false,
  bubble,
  bookedBy,
  onClose,
  avatar,
  archive,
  newChat,
  ...props
}) => {
  const nav = useNavStack(Stacks.Master);

  function goToPatientProfile() {
    if (patient.id) {
      let route = RouteUtils.getRoute(RouteUtils.routes().patient, {
        ':patientId': patient.id,
      });
      nav.push(route);
    }
  }

  const nameStr = name || PatientUtils.getName(patient);

  return (
    <div className="chat-content admin-top-bar">
      <div className="top-bar">
        <div className="patient-info">
          <span className="name truncate">{nameStr}</span>
          {!hideDetails && (
            <span className="gender-age">
              {PatientUtils.getGender(patient)} - {PatientUtils.getAge(patient)}
            </span>
          )}
          {bubble ? (
            <ChatDescription patient={patient} bubble={bubble} bookedBy={bookedBy} />
          ) : null}
          <div className="avatar-wrapper" onClick={goToPatientProfile}>
            {avatar || (!hideDetails && <PatientImage user={patient} size={70} />)}
          </div>
          {props.children}
        </div>
        <div className="buttons-left">
          {archive !== undefined && (
            <IconButton onClick={archive}>
              <Icon
                className="dark-grey"
                key={'archive-' + patient.id}
                src="box-archive"
                alt="Archive"
                showTooltip
                width="20px"
                height="20px"
              />
            </IconButton>
          )}
          {newChat !== undefined && (
            <IconButton onClick={newChat}>
              <Icon
                className="dark-grey"
                key={'new-chat-' + patient.id}
                src="message-plus"
                alt="New Chat"
                showTooltip
                width="20px"
                height="20px"
              />
            </IconButton>
          )}
          {props.extraLeftButtons}
        </div>
        <div className="buttons">
          {props.setFullScreen !== undefined && (
            <div className="button full-screen">
              <IconButton onClick={() => props.setFullScreen(!props.fullScreen)}>
                <Icon
                  className="dark-grey"
                  src={props.fullScreen ? 'compress' : 'expand'}
                  alt={props.fullScreen ? 'Exit Full Screen' : 'Enter Full Screen'}
                  showTooltip
                  height="20px"
                  width="20px"
                />
              </IconButton>
            </div>
          )}
          {props.extraButtons ?? null}
          <div className="button close">
            <IconButton onClick={onClose}>
              <Icon
                src="xmark"
                onClick={onClose}
                alt="Close"
                showTooltip
                width="20px"
                height="20px"
              />
            </IconButton>
          </div>
        </div>
      </div>
    </div>
  );
};

const ChatDescription = ({ patient, bubble, bookedBy }) => {
  const subscription = useAppSelector((state) => state.payments.subscriptions[patient?.id]);

  let spanStyle = { display: 'block', fontSize: '12px' };
  let chatDescription = (
    <span style={spanStyle}>
      Subscription: {SubscriptionUtils.getSubscriptionName(subscription)}
      <br />
      {ChatUtils.getChatDescriptionFromBubble(bubble)}
    </span>
  );

  if (bookedBy !== undefined && bookedBy.id !== patient.id)
    chatDescription = (
      <div>
        {chatDescription}
        <span style={spanStyle}>with {PatientUtils.getName(bookedBy)}</span>
      </div>
    );
  return <span className="chat-description">{chatDescription}</span>;
};

export default AdminTopBar;
